module.exports = __webpack_public_path__ + "static/media/write_to_raise_logo.528cb857.png";